import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerRentInComponent } from './dealer-rent-in.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DealerAlertsComponent } from '../dealer/dealer-alerts/dealer-alerts.component';

import { CustomerRentFavoritesComponent } from '../customer/customer-rent-favorites/customer-rent-favorites.component';
import { CustomerRentComponent } from '../customer/customer-rent/customer-rent.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';


const routes: Routes = [
  { path: '', component: DealerRentInComponent,
    children: [
      
      { path: 'favorites', canActivate: [AuthGuard], component: CustomerRentFavoritesComponent  },
            
      { path: 'bookings', canActivate: [AuthGuard], component: CustomerRentComponent, data: { transactionStages: [ TransactionStage.PENDING ] }},     
      { path: 'ongoing', canActivate: [AuthGuard], component: CustomerRentComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }},
      { path: 'completed', canActivate: [AuthGuard], component: CustomerRentComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }},
      
      { path: 'alerts', canActivate: [AuthGuard], component: DealerAlertsComponent, data: { businessLine: CarBusinessLine.RENT }  },
      
      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerRentInRoutingModule { }
